export const phoneIsValid = (phone?: string) => (phone ? phone.length === 10 : false);
